<script lang="ts">
	import CollapsibleCard from '#lib/components/CollapsibleCard.svelte';
	import type { HDGameReportResponseData } from '../types/responses/GameReport.js';

	let { game }: { game: HDGameReportResponseData } = $props();

	function calcTime(time: number) {
		const minutes = Math.floor(time / 60);
		const seconds = time % 60;
		return `${minutes}:${seconds.toString().padStart(2, '0')}`;
	}
</script>

{#snippet statsRow(label: string, homeValue?: any, awayValue?: any)}
	<div
		class="border-accent/75 mx-auto flex w-full max-w-[600px] items-end justify-between border-b-2"
	>
		<div class="basis-1/5 text-start text-3xl">{@html homeValue}</div>
		<div class="basis-3/5 text-center text-xl font-bold uppercase">{@html label}</div>
		<div class="basis-1/5 text-end text-3xl">{@html awayValue}</div>
	</div>
{/snippet}

<CollapsibleCard title="Team Stats" open>
	<div class="mb-3 flex w-full flex-col gap-3 overflow-x-auto">
		{@render statsRow(
			'PIM',
			game?.homeTeamStats.penaltyMinutes ?? 0,
			game?.awayTeamStats.penaltyMinutes ?? 0
		)}
		{@render statsRow(
			'Powerplay',
			`${game?.homeTeamStats.powerplayGoals ?? 0}&nbsp;/&nbsp;${game?.homeTeamStats.powerplayOpportunities ?? 0}`,
			`${game?.awayTeamStats.powerplayGoals ?? 0}&nbsp;/&nbsp;${game?.awayTeamStats.powerplayOpportunities ?? 0}`
		)}
		{@render statsRow(
			'Unterzahl',
			`${game?.homeTeamStats.penaltykillSuccesses ?? 0}&nbsp;/&nbsp;${game?.homeTeamStats.penaltykillSituations ?? 0}`,
			`${game?.awayTeamStats.penaltykillSuccesses ?? 0}&nbsp;/&nbsp;${game?.awayTeamStats.penaltykillSituations ?? 0}`
		)}
		{@render statsRow(
			'Führung',
			calcTime(game?.homeTeamStats.timeValues.leading ?? 0),
			calcTime(game?.awayTeamStats.timeValues.leading ?? 0)
		)}
		{@render statsRow(
			'Gleichstand',
			calcTime(game?.homeTeamStats.timeValues.tied ?? 0),
			calcTime(game?.awayTeamStats.timeValues.tied ?? 0)
		)}
		{@render statsRow(
			'Rückstand',
			calcTime(game?.homeTeamStats.timeValues.trailing ?? 0),
			calcTime(game?.awayTeamStats.timeValues.trailing ?? 0)
		)}
	</div>
</CollapsibleCard>
